<template>
    <el-dialog :title="dialogTitle" :visible.sync="visible" append-to-body
        :width="isMobile ? '98%' : '1000px'" top="3vh" custom-class="wangdu-map-dialog">
        <wangdu v-if="visible" @city-loaded="onCityLoaded"></wangdu>
    </el-dialog>
</template>
<script>
import wangdu from './wangdu.vue'

// 城市动态地图弹窗：不再跳独立页（原 router target=_blank），由顶栏/抽屉/帮助页原地呼出。
// v-if 随开随载：wangdu 自带 10s 轮询，关闭即 beforeDestroy 清定时器。
// 标题由内层地图按「玩家当前所在城市」回传，避免跨城后仍叫「王都地图」。
export default {
    name: 'wangduDialog',
    components: { wangdu },
    data() {
        return {
            visible: false,
            isMobile: window.innerWidth <= 768,
            cityName: ''
        }
    },
    computed: {
        dialogTitle() {
            return this.cityName ? this.cityName + ' · 动态地图' : '城市动态地图'
        }
    },
    methods: {
        open() {
            // 每次打开都重置：上次停在哪座城，标题不该留到下一次
            this.cityName = ''
            this.visible = true
        },
        onCityLoaded(city) {
            this.cityName = (city && city.cityname) ? city.cityname : ''
        }
    }
}
</script>
<style>
/* 非 scoped：命中 el-dialog 内部结构。给地图固定高，滚动画布交给 wangdu 内部 .map-scroll */
.wangdu-map-dialog .el-dialog__body {
    height: calc(86vh - 54px);
    padding: 0;
    overflow: hidden;
}
/* 移动端：App.vue 全局弹窗适配（body flex+overflow-y:auto，优先级更高）会打断上面的定高链，
   .map-scroll 因此失去定高、纵向不可滚——南部节点（如探索工会）落在 body 裁剪区外，定位失效。
   这里恢复定高链：弹窗定高 → body 弹性占满 → .map-scroll 成为唯一滚动容器（选择器压过 App.vue 全局规则） */
@media (max-width: 768px) {
    .el-dialog__wrapper .el-dialog.wangdu-map-dialog {
        height: 80vh;
        height: 80dvh;
        max-height: 80dvh;
    }
    .el-dialog__wrapper .el-dialog.wangdu-map-dialog .el-dialog__body {
        flex: 1 1 0;
        min-height: 0;
        height: auto;
        padding: 0;
        overflow: hidden;
    }
}
</style>
